
import { TranslationKey } from '../types';
import { uiActions } from './categories/ui-actions';
import { navigation } from './categories/it/navigation';
import { embedding } from './categories/embedding';
import { dialog } from './categories/dialog';
import { playback } from './categories/playback';
import { tracking } from './categories/tracking';
import { speedTesting } from './categories/speed-testing';
import { featureManagement } from './categories/feature-management';
import { autoplayOverlay } from './categories/autoplay-overlay';
import { videoContent } from './categories/video-content';
import { userAccount } from './categories/user-account';
import { userProfile } from './categories/user-profile';
import { VisualElements } from './categories/visual-elements';

export const it = {
  ...uiActions,
  ...navigation,
  ...embedding,
  ...dialog,
  ...playback,
  ...tracking,
  ...speedTesting,
  ...featureManagement,
  ...autoplayOverlay,
  ...videoContent,
  ...userAccount,
  ...userProfile,
  ...VisualElements,
  // Italian-specific translations for personal profile
  personal: 'Personale',
  language: 'Lingua',
  firstName: 'Nome',
  lastName: 'Cognome',
  email: 'Email',
  company: 'Azienda',
  currentPassword: 'Password Attuale',
  newPassword: 'Nuova Password',
  confirmNewPassword: 'Conferma Nuova Password',
  passwordRequirements: 'Requisiti Password',
  passwordRequirement1: 'Minimo 8 caratteri',
  passwordRequirement2: 'Almeno un numero',
  passwordRequirement3: 'Almeno una lettera maiuscola',
  security: 'Sicurezza',
} as Record<TranslationKey, string>;
